<template>
  <div class="profile">
    <nav-bar/>
    <div class="page-header">
      <div class="grid-container">
        <h1>Market</h1>
        <p>
          Lihat semua barang yang kamu bisa tukarkan dengan <i class="fas fa-coins golden-rod"></i><b> Zenny</b>!<br>
        </p>
      </div>
    </div>
    <div class="grid-container">
      <div class="flyout zenny-counter">
        <small>Sisa Zenny</small><br>
        <i class="fas fa-coins"></i><b> {{shownZenny.toFixed(0)}}</b>
      </div>
      <div class="market-content">
        <h1>Personalisasi</h1>
        <p>Beli dan ubah warna profilmu</p>
        <div class="personalization">
          <div class="personalization-item" v-for="(item, index) in userDataStore.colors" :key="index">
            <div class="mb-1">{{item.title}}</div>
            <div class="color-preview" :class="item.name">
              <div class="selected-tag" :class="{'selected': userDataStore.profileColor === item.name}">
                Dipilih
              </div>
            </div>
            <button class="btn my-1 btn--red btn--disabled" v-if="!item.isOwned && currentZenny < item.price">
              Beli <i class="fas fa-coins"></i><b> {{item.price}}</b>
            </button>
            <button class="btn my-1" @click="buyColor(index, item.price)" v-else-if="!item.isOwned">
              Beli <i class="fas fa-coins"></i><b> {{item.price}}</b>
            </button>
            <button class="btn btn--blue my-1" @click="setColor(item.name)" v-else-if="userDataStore.profileColor !== item.name">
              Atur
            </button>
            <button class="btn btn--disabled my-1" v-else>
              Atur
            </button>
          </div>
        </div>
      </div>
      <div class="market-content">
        <h1>Lesson dan Soal Tambahan</h1>
        <p>Beli soal-soal khusus</p>
        <div class="personalization">
          <div class="blank-item" v-for="(item, index) in 5" :key="index">

          </div>
        </div>
      </div>
      <div class="market-content">
        <h1>Lain-lain</h1>
        <p>Lihat semua yang ditawarkan oleh Blocode</p>
        <div class="personalization">
          <div class="blank-item" v-for="(item, index) in 10" :key="index">

          </div>
        </div>
      </div>
    </div>
    <footer-bar/>
  </div>
</template>

<script>
  import NavBar from '@/components/NavBar'
  import FooterBar from '@/components/FooterBar'

  export default {
    name: "Market",
    components: { NavBar, FooterBar },
    data() {
      return {
        shownZenny: 0,
      }
    },
    computed: {
      userDataStore() {
        return this.$store.state.userStore
      },
      currentZenny() {
        return this.$store.getters['userStore/getZenny']
      }
    },
    created() {
      this.shownZenny = this.currentZenny
    },
    methods: {
      buyColor(index, val) {
        this.$store.commit('userStore/decreaseZenny', {value: val})
        this.userDataStore.colors[index].isOwned = true

        const animatingZenny = setInterval(() => {
          if (this.shownZenny - this.currentZenny < 1) {
            this.shownZenny = this.currentZenny
            clearInterval(animatingZenny)
          } else {
            this.shownZenny -= (this.shownZenny - this.currentZenny) / 10
          }
        }, 20)
      },
      setColor(name) {
        this.$store.commit('userStore/setProfileColor', {color: name})
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "src/styles/colors";
  @import "src/styles/responsive";

  .market-content {
    margin-bottom: 2rem;

    .heading {
      margin-bottom: 1rem;
    }

    h1 {
      color: $blue;
      background: linear-gradient(to bottom right, #0C728B, $blue);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }


  .zenny-counter {
    position: sticky;
    top: 4rem;
    z-index: 10;
    padding: 0.5rem;
    min-width: 100px;
    margin-bottom: 1rem;
    display: inline-block;

    i, b {
      font-size: 1.3rem;
    }
  }

  .personalization {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;

    .personalization-item, .blank-item {
      margin: 0.5rem;
      flex-basis: 30%;
      text-align: center;
      background-color: rgba(black, 0.05);
      padding: 1rem;
      box-sizing: border-box;
      border-radius: 10px;

      @include mobile {
        flex-basis: calc(50% - 1rem);
      }
    }

    .blank-item {
      height: 100px;
    }

    .color-preview {
      height: 50px;
      width: 100%;
      border-radius: 10px;
      position: relative;
      overflow: hidden;
      z-index: 0;
    }
  }

  .selected-tag {
    position: absolute;
    top: -1.5rem;
    left: -3.25rem;
    padding: 2rem 3rem 0.25rem 3rem;
    transform: rotate(-30deg);
    font-weight: bold;
    mix-blend-mode: overlay;
    background-color: rgba(white, 0);
    color: rgba(black, 0);
    transition: background-color 0.1s, color 0.3s;
    user-select: none;

    &.selected {
      background-color: white;
      color: black;
    }
  }

  .blueGradient {
    background-image: linear-gradient(to bottom right, #296f99, #314380);
  }

  .redGradient {
    background-image: linear-gradient(to bottom right, #99263a, #61000a);
  }

  .orangeGradient {
    background-image: linear-gradient(to bottom right, #b87334, #612f02);
  }

  .greenGradient {
    background-image: linear-gradient(to bottom right, #34b847, #1f610f);
  }

  .violetGradient {
    background-image: linear-gradient(to bottom right, #b80083, #61214a);
  }

  .blueGreenGradient {
    background-image: linear-gradient(to bottom right, #2c9c6c, #173d7c);
  }

  .redOrangeGradient {
    background-image: linear-gradient(to bottom right, #c14d00, #6b0003);
  }

  .allColors {
    background: linear-gradient(270deg, #2aa750, #2aa750, #2a6fa7, #432aa7, #a72a9d, #9b2020, #b6831d, #88a72a, #2aa750, #2aa750);
    background-size: 1600% 1600%;
    animation: AnimationName 10s linear infinite;

    @keyframes AnimationName {
      0%{background-position:0 50%}
      100%{background-position:100% 50%}
    }
  }

  .dark-mode {
    .market-content h1 {
      filter: brightness(2) contrast(0.75);
    }
  }
</style>